import { Course } from './course';

export class ProgrammeCourse {
    id: number;
    programme_id: number;
    course_id: number;
    course: Course;
    constructor(programmeCourse?) {
        if (programmeCourse) {
            this.id = programmeCourse.id;
            this.programme_id = programmeCourse.programme_id;
            this.course_id = programmeCourse.course_id;
            this.course = programmeCourse.course;
        }
    }
}
